import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { agent } from '../../utils/agent';
import * as API from '../../utils/apiPath';
import { setToaster } from '../../utils/helpers';

// Async thunk for loading settings
export const loadSettingData = createAsyncThunk(
  'settings/loadSettingData',
  async (_, { rejectWithValue }) => {
    try {
      const response = await agent.get(API.SETTING);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to load settings data');
    }
  }
);

export const fetchSettings = createAsyncThunk(
  'setting/fetchSettings',
  async () => {
    try {
      const response = await agent.get(API.SETTING);
      return response.data.data;
    } catch (error) {
      return error?.message || 'Failed to load settings data'
    }
  });

export const fetchAllProgrammes = createAsyncThunk(
  'setting/fetchProgrammes',
  async () => {
    try {
      const response = await agent.get(API.LOAD_PROGRAMMES + "/all");
      return response?.data?.data;
    } catch (error) {
      return error?.message || 'Failed to load settings data'
    }
  });

// Create the slice
const settingsSlice = createSlice({
  name: 'settings',
  initialState: {
    setting: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearSettingsError: (state) => {
      state.error = null;
    },
    resetSettings: (state) => {
      state.setting = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadSettingData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loadSettingData.fulfilled, (state, action) => {
        state.loading = false;
        state.setting = action.payload;
      })
      .addCase(loadSettingData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        setToaster(action.payload, 'error');
      })
      .addCase(fetchSettings.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSettings.fulfilled, (state, action) => {
        state.loading = false;
        state.setting = action.payload;
      })
      .addCase(fetchSettings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchAllProgrammes.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllProgrammes.fulfilled, (state, action) => {
        state.programmes = action.payload;
      })
      .addCase(fetchAllProgrammes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

// Export actions
export const { clearSettingsError, resetSettings } = settingsSlice.actions;

// Export selectors
export const selectSetting = (state) => state.settings.setting;
export const selectSettingsLoading = (state) => state.settings.loading;
export const selectSettingsError = (state) => state.settings.error;

// Export reducer
export default settingsSlice.reducer;